import React from "react";
import { PhoneMissed, MessageSquare, Sparkles, BellRing } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

const stepIcons = [PhoneMissed, MessageSquare, Sparkles, BellRing];

export const HowItWorks = () => {
  const { t } = useI18n();
  return (
    <section className="pt-12 lg:pt-16 pb-20 lg:pb-24 relative" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-10">
          <div className="eyebrow mb-3">{t.how.eyebrow}</div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">{t.how.title}</h2>
          <p className="text-slate-400 mt-4 text-lg">{t.how.sub}</p>
        </div>

        <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {t.how.steps.map((s, i) => {
            const Icon = stepIcons[i] || Sparkles;
            return (
              <div key={i} className="glass rounded-2xl p-6 relative" data-testid={`how-step-${i}`}>
                <div className="flex items-center justify-between mb-6">
                  <div className="w-11 h-11 rounded-xl bg-blue-600/15 border border-blue-400/30 flex items-center justify-center text-cyan-300">
                    <Icon size={18} />
                  </div>
                  <span className="font-mono text-[10px] tracking-widest text-slate-500">{t.how.stepLabel} {s.n}</span>
                </div>
                <h3 className="font-display font-bold text-white text-xl leading-tight">{s.title}</h3>
                <p className="text-slate-400 text-sm mt-3 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
